<ng-container [formGroup]="data">
    <div class="passwords-wrapper">
        <div class="mb-3">
            <label class="form-label bold">{{label}}</label>
            <div class="password-wrapper">
                <input [type]="passwordtype" formControlName="password" required
                    [class.is-invalid]="data.get('password').hasError('required') && data.get('password').touched"
                    class="form-control">
                <i class="bi bi-eye mouse-pointer" [class.bi-eye]="passwordtype === 'password'"
                    [class.bi-eye-slash]="passwordtype !== 'password'"
                    (click)="passwordtype = passwordtype === 'password' ? 'text' : 'password'"></i>
            </div>
            <p class="input-error" *ngIf="data.get('password').hasError('required') && data.get('password').touched">
                Password is required!</p>
        </div>
        <div class="mb-3">
            <label class="form-label bold">Confirm {{label}}</label>
            <div class="password-wrapper">
                <input [type]="cpasswordtype" formControlName="cpassword" required
                    [class.is-invalid]="data.errors?.passwordError && (data.touched || data.dirty)"
                    class="form-control">
                <i class="bi bi-eye mouse-pointer" [class.bi-eye]="cpasswordtype === 'password'"
                    [class.bi-eye-slash]="cpasswordtype !== 'password'"
                    (click)="cpasswordtype = cpasswordtype === 'password' ? 'text' : 'password'"></i>
            </div>
            <p class="input-error" *ngIf="data.errors?.passwordError && (data.touched || data.dirty)">
                Password mismatch!</p>
        </div>
        <div class="row gx-1 mt-4 mb-3" *ngIf="data.get('password_strength').value">
            <div class="col">
                <div class="progress">
                    <div class="progress-bar" [class.bg-danger]="data.get('password_strength').value < 25"
                        [class.bg-warning]="data.get('password_strength').value >= 25 && data.get('password_strength').value < 50"
                        [class.bg-info]="data.get('password_strength').value >= 50 && data.get('password_strength').value < 75"
                        [class.bg-success]="data.get('password_strength').value >= 75" style="width: 100%;"
                        aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="col">
                <div class="progress">
                    <div class="progress-bar" [class.bg-muted]="data.get('password_strength').value < 25"
                        [class.bg-warning]="data.get('password_strength').value >= 25 && data.get('password_strength').value < 50"
                        [class.bg-info]="data.get('password_strength').value >= 50 && data.get('password_strength').value < 75"
                        [class.bg-success]="data.get('password_strength').value >= 75" style="width: 100%;"
                        aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="col">
                <div class="progress">
                    <div class="progress-bar" [class.bg-muted]="data.get('password_strength').value < 50"
                        [class.bg-info]="data.get('password_strength').value >= 50 && data.get('password_strength').value < 75"
                        [class.bg-success]="data.get('password_strength').value >= 75" style="width: 100%;"
                        aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="col">
                <div class="progress">
                    <div class="progress-bar" [class.bg-muted]="data.get('password_strength').value < 75"
                        [class.bg-success]="data.get('password_strength').value >= 75" style="width: 100%;"
                        aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="col-12 text-end">
                <small class="text-danger" *ngIf="data.get('password_strength').value < 25">Weak</small>
                <small class="text-warning"
                    *ngIf="data.get('password_strength').value >= 25 && data.get('password_strength').value < 50">Average</small>
                <small class="text-info"
                    *ngIf="data.get('password_strength').value >= 50 && data.get('password_strength').value < 75">Good</small>
                <small class="text-success" *ngIf="data.get('password_strength').value > 75">Strong</small>
            </div>
        </div>
    </div>
</ng-container>